import React from 'react'

function UpdateSection() {
  return (
    <div>UpdateSection</div>
  )
}

export default UpdateSection